import React, { useEffect, useState } from "react";
import LayerAdmin from "../LayerAdmin";
import { useNavigate, useParams } from "react-router-dom";
import { getSpecificCustomer, updateCustomer } from "../api/editCustomer";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../../components/Loader";
import URL_MAPPING from "../../../routes/constants";
import { setTime } from "react-datepicker/dist/date_utils";

const EditCustomer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    channel_id: "",
    channel_name: "",
    city: "",
    district: "",
    division_id: "",
    division_name: "",
    house_no: "",
    latitude: "",
    longitude: "",
    mobile_number: "",
    b2b_mobile: "",
    outlet_id: "",
    outlet_name_ar: "",
    outlet_name_en: "",
    payer_id: "",
    payment_term_id: "",
    payment_term_name: "",
    postcode: "",
    sales_office_id: "",
    sales_office_name: "",
    status: "",
    vat: "",
    email:"",
    territory_entity_key:"",
    preseller_id:"",
  });

  const excludeFields = new Set([
    "channel_id",
    "channel_name",
    "city",
    "district",
    "division_id",
    "division_name",
    "house_no",
    "latitude",
    "longitude",
    "b2b_mobile",
    "outlet_id",
    "outlet_name_ar",
    "outlet_name_en",
    "payer_id",
    "payment_term_id",
    "payment_term_name",
    "postcode",
    "sales_office_id",
    "sales_office_name",
    "status",
    "vat",
  ]);

  const handleGetData = async () => {
    try {
      if (id) {
        setLoading(true);
        const response = await getSpecificCustomer(id);
        if (!response) {
          console.warn("Invalid or empty response:", response);
          toast.error("Invalid or empty response");
          return;
        }
        setFormData({
          channel_id: response.channel_id ?? "",
          channel_name: response.channel_name ?? "",
          city: response.city ?? "",
          district: response.district ?? "",
          division_id: response.division_id ?? "",
          division_name: response.division_name ?? "",
          house_no: response.house_no ?? "",
          latitude: response.latitude ?? "",
          longitude: response.longitude ?? "",
          mobile_number: response.mobile_number ?? "",
          b2b_mobile: response.b2b_mobile ?? "",
          outlet_id: response.outlet_id ?? "",
          outlet_name_ar: response.outlet_name_ar ?? "",
          outlet_name_en: response.outlet_name_en ?? "",
          payer_id: response.payer_id ?? "",
          payment_term_id: response.payment_term_id ?? "",
          payment_term_name: response.payment_term_name ?? "",
          postcode: response.postcode ?? "",
          sales_office_id: response.sales_office_id ?? "",
          sales_office_name: response.sales_office_name ?? "",
          status: response.status ?? "",
          vat: response.vat ?? "",
          email: response.email ?? "",
          preseller_id: response.preseller_id ?? "",
          territory_entity_key: response.territory_entity_key ?? "",
        });
      }
    } catch (error: any) {
      console.error("Error fetching customer data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error("Error while fetching the customer");
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      if (id) {
        setUpdating(true);
        setInvalidFields([]);
        // const emptyFields = Object.entries(formData)
        //   .filter(
        //     ([key, value]) =>
        //       !excludeFields.has(key) && (value === null || value === "")
        //   )
        //   .map(([key]) => key);

        // setInvalidFields(emptyFields);

        // if (emptyFields.length > 0) {
        //   toast.error("Please fill all required fields.");
        //   return;
        // }
        const response = await updateCustomer(formData, formData.outlet_id);
        if (!response) {
          console.warn("Invalid or empty response:", response);
          toast.error("Invalid or empty response", {
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
          return;
        }
        toast.success("Customer updated successfully");
        setTimeout(() => {
          navigate(URL_MAPPING.CUSTOMERS);
        }, 2000);
       
      }
    } catch (error: any) {
      console.error("Error fetching customer data:", error, {
        autoClose: false,
        closeOnClick: true,
        draggable: true,
      });
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later", {
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else if (error?.response?.status === 500) {
        toast.error("Error while updating the customer", {
          autoClose: false,
          closeOnClick: true,
          draggable: true,
        });
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg,{
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          }));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.", {
            autoClose: false,
            closeOnClick: true,
            draggable: true,
          });
        }
      }
    } finally {
      setUpdating(false);
    }
  };

  useEffect(() => {
    handleGetData();
  }, [id]);

  return (
    <LayerAdmin>
      <ToastContainer />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="flex items-center px-5 pt-5 gap-3">
            <button
              onClick={() => window.history.back()}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                version="1.1"
                width="10"
                height="10"
                viewBox="0 0 256 256"
                xmlSpace="preserve"
              >
                <g
                  style={{
                    stroke: "none",
                    strokeWidth: 0,
                    strokeDasharray: "none",
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeMiterlimit: 10,
                    fill: "none",
                    fillRule: "nonzero",
                    opacity: 1,
                  }}
                  transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
                >
                  <polygon
                    points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                    style={{
                      stroke: "none",
                      strokeWidth: 1,
                      strokeDasharray: "none",
                      strokeLinecap: "butt",
                      strokeLinejoin: "miter",
                      strokeMiterlimit: 10,
                      fill: "rgb(0,0,0)",
                      fillRule: "nonzero",
                      opacity: 1,
                    }}
                    transform="  matrix(1 0 0 1 0 0) "
                  />
                </g>
              </svg>
            </button>
            <h3 className="text-xl font-bold text-gray-700">Edit Customer</h3>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm px-5 pt-5">
            <div>
              <label className="block font-semibold mb-1">Channel ID</label>
              <input
                type="text"
                value={formData.channel_id}
                onChange={handleChange}
                disabled
                name="channel_id"
              />
            </div>
            <div>
              <label className="block font-semibold mb-1">Email*</label>
              <input
                type="text"
                value={formData.email}
                onChange={handleChange}
                className={getInputClass("email")}
                name="email"
              />
            </div>
            <div>
              <label className="block font-semibold mb-1">Territory Entity Key*</label>
              <input
                type="text"
                value={formData.territory_entity_key}
                onChange={handleChange}
                className={getInputClass("territory_entity_key")}
                name="territory_entity_key"
                
              />
            </div>
            <div>
              <label className="block font-semibold mb-1">Pre Seller ID*</label>
              <input
                type="text"
                value={formData.preseller_id}
                onChange={handleChange}
                className={getInputClass("preseller_id")}
                name="preseller_id"
                
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Channel Name</label>
              <input
                type="text"
                value={formData.channel_name}
                onChange={handleChange}
                name="channel_name"
                disabled
                className={getInputClass("channel_name")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">City</label>
              <input
                type="text"
                value={formData.city}
                onChange={handleChange}
                disabled
                name="city"
                className={getInputClass("city")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">District</label>
              <input
              disabled
                type="text"
                value={formData.district}
                onChange={handleChange}
                name="district"
                className={getInputClass("district")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Division ID</label>
              <input
                type="text"
                disabled
                value={formData.division_id}
                onChange={handleChange}
                name="division_id"
                className={getInputClass("division_id")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Division Name</label>
              <input
                type="text"
                disabled
                value={formData.division_name}
                onChange={handleChange}
                name="division_name"
                className={getInputClass("division_name")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">House No</label>
              <input
                type="text"
                value={formData.house_no}
                onChange={handleChange}
                disabled
                name="house_no"
                className={getInputClass("house_no")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Latitude</label>
              <input
                type="text"
                value={formData.latitude}
                disabled
                onChange={handleChange}
                name="latitude"
                className={getInputClass("latitude")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Longitude</label>
              <input
                type="text"
                value={formData.longitude}
                disabled
                onChange={handleChange}
                name="longitude"
                className={getInputClass("longitude")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Mobile Number</label>
              <input
                type="text"
                value={formData.mobile_number}
                onChange={handleChange}
                name="mobile_number"
                className={getInputClass("mobile_number")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">B2B Mobile Number</label>
              <input
                type="text"
                value={formData.b2b_mobile}
                onChange={handleChange}
                name="b2b_mobile"
                className={getInputClass("mobile_number")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Outlet ID</label>
              <input
                type="text"
                value={formData.outlet_id}
                onChange={handleChange}
                disabled
                name="outlet_id"
                className={getInputClass("outlet_id")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">
                Outlet Name (AR)
              </label>
              <input
                type="text"
                value={formData.outlet_name_ar}
                onChange={handleChange}
                disabled
                name="outlet_name_ar"
                className={getInputClass("outlet_name_ar")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">
                Outlet Name (EN)
              </label>
              <input
                type="text"
                value={formData.outlet_name_en}
                onChange={handleChange}
                disabled
                name="outlet_name_en"
                className={getInputClass("outlet_name_en")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Payer ID</label>
              <input
                type="text"
                value={formData.payer_id}
                onChange={handleChange}
                name="payer_id"
                disabled
                className={getInputClass("payer_id")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">
                Payment Term ID
              </label>
              <input
                type="text"
                value={formData.payment_term_id}
                onChange={handleChange}
                disabled
                name="payment_term_id"
                className={getInputClass("payment_term_id")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">
                Payment Term Name
              </label>
              <input
                type="text"
                disabled
                value={formData.payment_term_name}
                onChange={handleChange}
                name="payment_term_name"
                className={getInputClass("payment_term_name")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Postcode</label>
              <input
                type="text"
                disabled
                value={formData.postcode}
                onChange={handleChange}
                name="postcode"
                className={getInputClass("postcode")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">
                Sales Office ID
              </label>
              <input
              disabled
                type="text"
                value={formData.sales_office_id}
                onChange={handleChange}
                name="sales_office_id"
                className={getInputClass("sales_office_id")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">
                Sales Office Name
              </label>
              <input
              disabled
                type="text"
                value={formData.sales_office_name}
                onChange={handleChange}
                name="sales_office_name"
                className={getInputClass("sales_office_name")}
              />
            </div>

            <div>
              <label className="block font-semibold mb-1">Status</label>
              {/* <input
                type="text"
                value={formData.status}
                onChange={handleChange}
                disabled
                name="status"
                className={getInputClass("status")}
              /> */}
              <select
      value={formData.status}
      onChange={(e) =>
        setFormData((prev) => ({ ...prev, status: e.target.value }))
      }
      name="status"
      className={getInputClass("status")}
    >
      <option value="A">Active</option>
      <option value="I">Inactive</option>
    </select>
            </div>

            <div>
              <label className="block font-semibold mb-1">VAT</label>
              <input
                type="text"
                value={formData.vat}
                onChange={handleChange}
                name="vat"
                disabled
                className={getInputClass("vat")}
              />
            </div>
          </div>

          <div className="mt-4 px-5">
            <button
              onClick={handleSubmit}
              disabled={updating}
              className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
            >
              Update Customer {updating && <ButtonLoader />}
            </button>
          </div>
        </>
      )}
    </LayerAdmin>
  );
};

export default EditCustomer;
